import { render, staticRenderFns } from "./CardBoutique.vue?vue&type=template&id=6e2cdd0a&"
import script from "./CardBoutique.vue?vue&type=script&lang=js&"
export * from "./CardBoutique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports